import { render, staticRenderFns } from "./CreateLeaderDialog.vue?vue&type=template&id=5561d6ce&scoped=true&"
import script from "./CreateLeaderDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateLeaderDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5561d6ce",
  null
  
)

export default component.exports